import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';

export const findTeamData= (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-cluster/v1/cluster/list?`+params,
        method: 'GET'
    })
}